import { FC, SVGProps } from 'react';

export const CalendarIcon: FC<SVGProps<SVGSVGElement>> = props => (
    <svg
        width={20}
        height={20}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect
            x={2}
            y={3}
            width={16}
            height={15}
            rx={2}
            stroke="currentColor"
            strokeWidth={1.5}
        />
        <path
            d="M2 6.5h16"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
        />
        <path
            d="M6.5 1v4"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
        />
        <path
            d="M13.5 1v4"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
        />
        <path
            d="M8.25 11.25 9.9 13l2.85-3.5"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CalendarIcon;
